import type { ButtonProps } from "@mantine/core";
import { Box, Button, Collapse, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

interface ExtendableProps {
  children: React.ReactNode;
  moreLabel?: string;
  lessLabel?: string;
  buttonProps?: Omit<ButtonProps, "onClick" | "children">;
}

function Extendable({
  children,
  moreLabel = "Mehr anzeigen",
  lessLabel = "Weniger anzeigen",
  buttonProps
}: ExtendableProps) {
  const [opened, { toggle }] = useDisclosure(false);

  return (
    <Box className="Extendable">
      <Collapse expanded={opened}>{children}</Collapse>
      <Button
        fw="normal"
        m={5}
        px={0}
        variant="transparent"
        onClick={toggle}
        {...buttonProps}
      >
        <Group gap={3}>
          {opened ? (
            <>
              <IconChevronUp strokeWidth="1" />
              {lessLabel}
            </>
          ) : (
            <>
              <IconChevronDown strokeWidth="1" />
              {moreLabel}
            </>
          )}
        </Group>
      </Button>
    </Box>
  );
}

export { Extendable, ExtendableProps };
